import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
import moment from '../../moment-hawaii';
import ticketAvailabilityInfo from '../ticket-picker/ticketAvailabilityInfo';
import TicketList from '../ticket-picker/TicketList';

function MultipleTicketModal({
    onSubmit,
    tickets,
    groupSize,
    showModal,
    MODAL_TYPE,
    startTime,
    userRole
}) {
    const [ticketCounts, setTicketCounts] = useState([]);
    useEffect(() => {
        // on first load add all tickets to the first ticket type
        setTicketCounts(
            tickets.map(e => {
                return {
                    id: e.id,
                    value: 0
                };
            })
        );
    }, [setTicketCounts, tickets, groupSize]);

    const isAvailable = ticket => ticketAvailabilityInfo(ticket, startTime).available;
    const availableTickets = tickets.filter(isAvailable);
    const anySelected = ticketCounts.some(t => t.value > 0);

    return (
        <Dialog
            aria-labelledby="multipleticket-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>{`Available ticket(s) - ${moment(startTime).format(
                'ddd, MMM DD h:mm'
            )}`}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <TicketList
                        tickets={tickets}
                        startTime={startTime}
                        role={userRole}
                        ticketCounts={ticketCounts}
                        setTicketCounts={setTicketCounts}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => {
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        onSubmit(ticketCounts);
                        showModal(MODAL_TYPE.NONE);
                    }}
                    disabled={!anySelected || availableTickets.length === 0}
                >
                    Add tickets
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MultipleTicketModal;
